import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useIsVirtualMarketer = () => {
  const workspace = useCurrentWorkspace()
  return workspace?.is_virtual_marketer
}
